import React, { useState } from "react";
import QuizData from './QuizData'
import QuizResult from './QuizResult';

const Quiz = () => {
  const [currQuestion, setCurrQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [clickOpt, setClickOpt] = useState(0);
  const [resBar, setResBar] = useState("")
  const [checkClr, setCheckClr] = useState("0")
  const [gameOver, setGameOver] = useState(false)

  const handleNext = () => {
    updateScore();
    if (currQuestion < QuizData.length - 1) {
      setCurrQuestion(currQuestion + 1);
      setClickOpt(0)
    } else {
      setGameOver(true)
    }
  };
  const updateScore = async() => {
    if (clickOpt === QuizData[currQuestion].answer) {
      setScore(score + 1);
      setResBar("Correct")
      setCheckClr("1")
      setTimeout(() => {
        setResBar("")
      }, 1200);
    }
    else{
      setResBar("Wrong")
      setCheckClr("0")
      setTimeout(() => {
        setResBar("")
      }, 1200);
    }
  };
  
  const resetAll = ()=>{
    setCurrQuestion(0)
    setScore(0)
    setClickOpt(0)
    setGameOver(false)
    setResBar("")
  }

  return (
    <>
      <div style={{ display: 'flex', marginTop: '80px', alignItems: 'center', justifyContent: 'center', backgroundColor: '#3aaccb', minHeight: '100vh', width: '100%' }}>
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', minHeight: '400px', width: '500px', backgroundColor: 'white', borderRadius: '15px', boxShadow: '2px 2px 10px 1px #333', overflow: 'hidden', padding: '10px', position: 'relative' }}>
          <p style={{ color: 'white', fontSize: '30px', fontWeight: 'bold', margin: '10px', textAlign: 'center', textTransform: 'uppercase' }}>Quiz Game</p>
          {gameOver ? (
            <QuizResult score={score} totalQuestion={QuizData.length} tryAgain={resetAll}/>
          ):(
          <>
          <div style={{ margin: '8px', boxShadow: '0px 0px 10px 1px #a2a3a3', borderRadius: '5px', padding: '5px', fontSize: 'larger', fontFamily: 'Times New Roman, Times, serif', minWidth: '100%', minHeight: '90px', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: '900' }}><span style={{ marginRight: '5px' }}>{currQuestion + 1}. </span><span>{QuizData[currQuestion].question}</span></div>
          <h2 style={{ fontSize: '20px', fontWeight: '800', color: `${checkClr === "1" ? "green" : "red"}` }}>{resBar}</h2>
          <div style={{ display: 'flex', flexDirection: 'column', margin: '6px 4px', width: '100%', padding: '10px' }}>
            {QuizData[currQuestion].options.map((elm, idx) => {
              return (
                <button
                  className={`option-btn ${clickOpt === idx+1?"checked":null}`}
                  onClick={() => {
                    setClickOpt(idx + 1);
                  }}
                  key={idx}
                  style={{ boxShadow: '0px 0px 4px 1px rgb(128, 123, 123)', padding: '5px', borderRadius: '3px', border: 'none', outline: 'none', transition: '0.3s', margin: '5px', minHeight: '30px', backgroundColor: 'white', textAlign: 'center', color: 'black', width: '200px' }}
                >
                  {elm}
                </button>
              );
            })}
          </div>
          <button
            type="button"
            style={{ width: '80px', fontSize: '18px', fontWeight: '700', marginTop: '10px' }}
            className="btn btn-outline-info"
            onClick={handleNext}
          >
            Next
          </button>
          </>
          )}
        </div>
      </div>
    </>
  );
};

export default Quiz;
